/*
 * @Description: hooks for currency selection
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchSalesChannelCurrencyList } from './slice';

const useGetPageCurrencyList = (salesChannelUuid: string) => {
  const d = useDispatch();
  const getList = () => {
    if (salesChannelUuid) {
      d(fetchSalesChannelCurrencyList({ salesChannelUuid }));
    }
  };
  React.useEffect(() => {
    getList();
  }, [salesChannelUuid]);
};

export { useGetPageCurrencyList };
